import React from "react";
import { useEmployeeFilters } from "../Employees/hooks/useEmployeeFilter";
import { useEmployees } from "../Employees/hooks/useEmployees";
import { EmployeeFilters } from "./components/EmployeeFilter";
import { EmployeeTable } from "./components/EmployeeTable";
import { Pagination } from "./components/Pagination";
import { EmployeeEditModal } from "./components/StatusEditModal";
import axios from "axios";
import toast from "react-hot-toast";
import { Admin_Employee } from "../../../constants";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const Employees = () => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [selectedEmployee, setSelectedEmployee] = React.useState(null);
  const [statusLoading, setStatusLoading] = React.useState(false);

  const {
    search,
    setSearch,
    filterActive,
    setFilterActive,
    filterRole,
    setFilterRole,
    page,
    setPage,
    resetFilters,
    filters,
  } = useEmployeeFilters();

  const {
    employees,
    loading,
    error,
    totalPages,
    totalEmployees,
    availableRoles,
    limit,
    refetch,
  } = useEmployees(filters);

  const handleEditEmployee = (employee) => {
    setSelectedEmployee(employee);
    setModalOpen(true);
  };

  const handleConfirmEdit = async (updated) => {
    if (!selectedEmployee) return;
    setStatusLoading(true);
    try {
      const res = await axios.put(
        `${Admin_Employee}/${selectedEmployee.EmployeeId}/status`,
        {
          EmployeeName: updated.EmployeeName,
          EmployeePhone: updated.EmployeePhone,
          EmployeeMailId: updated.EmployeeMailId,
          is_active: updated.is_active,
          EmployeeId: updated.EmployeeId,
          EmployeeRoleID: updated.EmployeeRoleID,
        }
      );
      if (res.data.success) {
        await refetch();
        toast.success(
          `Employee ${updated.EmployeeName}'s details updated successfully!`
        );
      } else {
        alert(res.data.message || "Failed to update employee");
      }
    } catch (err) {
      alert(
        err.response?.data?.message ||
          err.message ||
          "Failed to update employee"
      );
    } finally {
      setStatusLoading(false);
      setModalOpen(false);
      setSelectedEmployee(null);
    }
  };

  const handleBack = () => {};

  return (
    <>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link
          underline="hover"
          key="1"
          color="inherit"
          to="/settings"
          onClick={handleBack}
        >
          Admin Panel
        </Link>
        <Typography key="2" color="text.primary">
          Employee
        </Typography>
      </Breadcrumbs>

      <div className="min-h-screen bg-base-100 p-4 lg:p-6">
        <div className="max-w-7xl mx-auto">
          <EmployeeFilters
            search={search}
            setSearch={setSearch}
            filterActive={filterActive}
            setFilterActive={setFilterActive}
            filterRole={filterRole}
            setFilterRole={setFilterRole}
            setPage={setPage}
            availableRoles={availableRoles}
            resetFilters={resetFilters}
            totalEmployees={totalEmployees}
          />
          <EmployeeTable
            employees={employees}
            loading={loading}
            error={error}
            onEditStatus={handleEditEmployee}
          />
          <Pagination
            page={page}
            totalPages={totalPages}
            totalEmployees={totalEmployees}
            limit={limit}
            onPageChange={setPage}
          />
          <EmployeeEditModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            employee={selectedEmployee}
            onConfirm={handleConfirmEdit}
            loading={statusLoading}
          />
        </div>
      </div>
    </>
  );
};

export default Employees;
